import React, { useState, useEffect } from 'react'
// import FormattedDateFromInt from './FormattedDateFromInt'
// import FormatDateObjectToInt from './FormatDateObjectToInt'
import GetmoviesAppInfoConfigService from '../../Services/Queries/GetmoviesAppInfoConfigService'
import MoviePosterCdn from './MoviePosterCdn'
import OttPlatformPopUp from './OttPlatformPopUp'
import OttDateMonthYear from './OttDateMonthYear'
import OttLinkField from './OttLinkField'
import Select from 'react-select'
// import OttImageComponent from './OttImageComponent'

const Ottplatformlink = props => {
  const {
    Movielinks,
    ott,
    inputData,
    sendBooleanValueChangeDone,
    sendinputdata,
    sendlinks,
    sendott,
  } = props
  const [pop, setPop] = useState(false)
  const [ottindex, setOttindex] = useState('')
  const [link, setLink] = useState(true)
  // const [ottPreviousDate, setOttPreviousDate] = useState(false)
  // const [ottTime, setOttReleaseTime] = useState('')
  // const [formattedMonthDate, setFormattedMonthDate] = useState(null)
  const [date, setdate] = useState('')
  // const [year, setYear] = useState('')
  const [options, setOptions] = useState([])
  const [ottStatus, setOttStatus] = useState(null)

  const statusOptions = [
    {
      value: 'OTTNotAvailable',
      label: 'OTT Not Available',
    },
    {
      value: 'OTTProviderRevealedAndDateTBA',
      label: 'OTT Provider Revealed,Date TBA',
    },
    {
      value: 'OTTProviderRevealedAndLinkAvailableAndDateNotKnown',
      label: 'OTT Provider Revealed,Link Avail.,Date Not Known',
    },
    {
      value: 'OTTProviderRevealedAndDateAnnounced',
      label: 'OTT Provider Revealed,Date Announced',
    },
    {
      value:
        'OTTProviderAndDateKnownAndLinkNotAvailable',
      label:
        'OTT Provider & Date Known,Link Not Available',
    },
    {
      value: 'OTTProviderDateAndLinkAvailable',
      label: 'OTT Provider,Date & Link Available',
    },
    // {
    //   value: 'shelved',
    //   label: 'shelved',
    // },
  ]
  // const dateValidation = Movielinks.some(e => e.link && e.link !== '')
  //   ? date !== '' || formattedMonthDate !== '' || year !== ''
  //   : false

  const ottSelect = value => {
    const temp = [...ott]
    temp[ottindex] = value
    sendott('ott', temp)
    setPop(false)
    sendBooleanValueChangeDone('ott', true)
  }

  const renderOttOptions = options.map((e, index) => (
    <div key={index} className='restrictionage1' style={{ display: 'flex' }}>
      <div
        style={{ display: 'flex', align: 'horizontal' }}
        onClick={() => ottSelect(e)}
      >
        <img src={MoviePosterCdn(e.value)} height='50' width='50' />
      </div>
    </div>
  ))

  // const handleOttReleaseTime = event => {
  //   setOttReleaseTime(event.target.value)
  //   setFormattedMonthDate(null)
  //   setdate('')
  //   setYear('')
  // }

  const defaultBehaviourEnter = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  const addFields = () => {
    const newField = { link: '' }
    const newOtt = { label: '', value: '' }
    const updatedOtt = [...ott, newOtt]
    const updatedMovielinks = [...Movielinks, newField]
    sendinputdata({
      ...inputData,
      ott: updatedOtt,
      Movielinks: updatedMovielinks,
    })
  }

  const removeFields = index => {
    // Send a boolean value change indicating that an ott field has been removed
    sendBooleanValueChangeDone('ott', true)

    // Filter out the movie link and ott at the specified index
    const updatedMovielinks = Movielinks.filter((_, idx) => idx !== index)
    const updatedOtt = ott.filter((_, idx) => idx !== index)

    // If there are no more movie links after removal, reset certain state values
    if (updatedMovielinks.length === 0) {
      setdate('')
    }

    // Get the platform label for the current index
    const platformLabel = ott[index]?.label || ''

    // Find the index of the platform in the input data
    const matchedPlatformIndex = inputData.OTTPlatformsWithLangs.findIndex(
      platform => platform.availablePlatform === platformLabel,
    )

    // Remove the platform from inputData.OTTPlatformsWithLangs if found
    if (matchedPlatformIndex === -1) {
      // Update the inputData state without modifying OTTPlatformsWithLangs
      sendinputdata({
        ...inputData,
        ott: updatedOtt,
        Movielinks: updatedMovielinks,
      })
    } else {
      const updatedOTTPlatformsWithLangs = [...inputData.OTTPlatformsWithLangs]
      updatedOTTPlatformsWithLangs.splice(matchedPlatformIndex, 1)

      // Update the inputData state with the removed platform
      sendinputdata({
        ...inputData,
        OTTPlatformsWithLangs: updatedOTTPlatformsWithLangs,
        ott: updatedOtt,
        Movielinks: updatedMovielinks,
      })
    }
  }

  const links = (value, index) => {
    sendBooleanValueChangeDone('ott', true)

    const updatedMovielinks = [...Movielinks]
    const updatedField = updatedMovielinks[index]
    updatedField.link = value

    if (value) {
      const regex = /(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[\\/\w .-]*\/?/
      setLink(regex.test(value))
    }

    updatedMovielinks[index] = updatedField
    sendlinks('Movielinks', updatedMovielinks)
  }

  const changeOttDate = async (dateType, value, index) => {
    let formattedDate = ''

    if (dateType === 'date') {
      setdate(value)
      formattedDate = parseInt(value.split('-').join(''), 10)
    }

    // if (dateType === 'month') {
    //   const selectedDate = new Date(value)
    //   formattedDate = await FormatDateObjectToInt(dateType, selectedDate)
    //   setFormattedMonthDate(value)
    // }

    // if (dateType === 'year') {
    //   if (value === '') {
    //     setYear('')
    //   } else {
    //     formattedDate = parseInt(value, 10)
    //     setYear(new Date(formattedDate + '-01-01'))
    //   }
    // }

    sendBooleanValueChangeDone('ott', true)

    const updatedMovielinks = [...Movielinks]
    const updatedField = updatedMovielinks[index]
    updatedField.ottDate = formattedDate
    updatedField.ottDateUi = formattedDate
    updatedMovielinks[index] = updatedField
    sendlinks('Movielinks', updatedMovielinks)
  }

  const restrictpop = () => {
    setPop(!pop)
  }

  const updateDate = async () => {
    // let ottPreviousDate = false

    // if (
    //   inputData &&
    //   inputData.Movielinks &&
    //   inputData.Movielinks[0] &&
    //   inputData.Movielinks[0].ottDate
    // ) {
    //   ottPreviousDate = true
    //   const dateInInteger = inputData.ottDate
    //   ottPreviousDate = await FormattedDateFromInt(dateInInteger)
    //   setOttPreviousDate(ottPreviousDate)
    // }

    if (inputData.ottDate) {
      const dateInInteger = inputData.ottDate
      const date = dateInInteger.toString()

      if (date.length === 8) {
        setdate(inputData.Movielinks[0].ottDate)
        // setOttReleaseTime('date')
      }

      // if (date.length === 6) {
      //   setOttReleaseTime('month')
      //   const dateInIntegerTemp = FormattedDateFromInt(date) + '-01'
      //   const monthandyearformatdate = new Date(dateInIntegerTemp)
      //   setFormattedMonthDate(monthandyearformatdate)
      // }

      // if (date.length === 4) {
      //   setOttReleaseTime('year')
      //   setYear(new Date(dateInInteger + '-01-01'))
      // }
    }
  }

  // const handleImageClick = () => {
  //   setOttindex(index)
  //   setPop(true)
  // }
  const handleMovieStatusChange = selectedOption => {
    const newOttStatus = selectedOption.value
    const inputDataTemp = { ...inputData, OTTStatus: newOttStatus }
    sendinputdata(inputDataTemp)
    sendBooleanValueChangeDone('OTTStatus', true)
    setOttStatus(selectedOption)
  }

  useEffect(() => {
    let status = { value: 'OTTProviderDateAndLinkAvailable', label: 'OTT Provider,Date & Link Available' }

    if (inputData.OTTStatus.includes('OTTNotAvailable')) {
      status = {
        value: 'OTTNotAvailable',
        label: 'OTT Not Available',
      }
    } else if (
      inputData.OTTStatus.includes(
        'OTTProviderAndDateKnownAndLinkNotAvailable',
      )
    ) {
      status = {
        value:
          'OTTProviderAndDateKnownAndLinkNotAvailable',
        label:
          'OTT Provider & Date Known,Link Not Available',
      }
    } else if (
      inputData.OTTStatus.includes(
        'OTTProviderDateAndLinkAvailable',
      )
    ) {
      status = {
        value: 'OTTProviderDateAndLinkAvailable',
        label: 'OTT Provider,Date & Link Available',
      }
    } else if (
      inputData.OTTStatus.includes(
        'OTTProviderRevealedAndDateTBA',
      )
    ) {
      status = {
        value: 'OTTProviderRevealedAndDateTBA',
        label: 'OTT Provider Revealed,Date TBA',
      }
    } else if (
      inputData.OTTStatus.includes(
        'OTTProviderRevealedAndDateAnnounced',
      )
    ) {
      status = {
        value: 'OTTProviderRevealedAndDateAnnounced',
        label: 'OTT Provider Revealed,Date Announced',
      }
    } else if (
      inputData.OTTStatus.includes(
        'OTTProviderRevealedAndLinkAvailableAndDateNotKnown',
      )
    ) {
      status = {
        value: 'OTTProviderRevealedAndLinkAvailableAndDateNotKnown',
        label: 'OTT Provider Revealed,Link Avail.,Date Not Known',
      }
    }
    //  else if (inputData.OTTStatus.includes('shelved')) {
    //   status = {
    //     value: 'shelved',
    //     label: 'shelved',
    //   }
    // }

    setOttStatus(status)

    const inputDataTemp = { ...inputData, OTTStatus: status.value }
    sendinputdata(inputDataTemp)
  }, [inputData.OTTStatus])

  useEffect(() => {
    const fetchMoviesAppInfo = async () => {
      const appInfoData = await GetmoviesAppInfoConfigService()
      setOptions(
        appInfoData.getMoviesAppInfoConfig.ottList
          .map(e => ({ ...e, value: e.url }))
          .filter(ott => ott.label !== 'All'),
      )
    }

    fetchMoviesAppInfo()
    updateDate()
  }, [inputData.ottDate])

  return (
    <>
      <div style={{ width: '70%' }}>
        <label className='label'>Ott Status:</label>
        <Select
          options={statusOptions}
          value={ottStatus}
          onChange={handleMovieStatusChange}
        />
      </div>
      <OttLinkField
        Movielinks={Movielinks}
        // ottPreviousDate={ottPreviousDate}
        ott={ott}
        links={links}
        defaultBehaviourEnter={defaultBehaviourEnter}
        removeFields={removeFields}
        inputData={inputData}
        sendinputdata={sendinputdata}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        link={link}
        setOttindex={setOttindex}
        setPop={setPop}
        ottStatus={ottStatus}
      />

      {(ottStatus?.value ===
        'OTTProviderRevealedAndDateAnnounced' ||
        ottStatus?.value ===
          'OTTProviderAndDateKnownAndLinkNotAvailable' ||
        ottStatus?.value ===
          'OTTProviderDateAndLinkAvailable') && (
        <OttDateMonthYear
          // ottTime={ottTime}
          // handleOttReleaseTime={handleOttReleaseTime}
          date={date}
          // formattedMonthDate={formattedMonthDate}
          changeOttDate={changeOttDate}
          // year={year}
          // Movielinks={Movielinks}
          // inputData={inputData}
          // sendinputdata={sendinputdata}
          // sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        />
      )}

      {/* {dateValidation && (
        <span className='mandatory1'>
          Ott date should not be empty if the release year is 2015 and above
        </span>
      )} */}

      {(ottStatus?.value === 'ott and link available' ||
        ottStatus?.value ===
          'OTTProviderAndDateKnownAndLinkNotAvailable' ||
        ottStatus?.value ===
          'OTTProviderDateAndLinkAvailable' ||
        ottStatus?.value === 'OTTProviderRevealedAndDateTBA' ||
        ottStatus?.value ===
          'OTTProviderRevealedAndDateAnnounced' ||
        ottStatus?.value ===
          'OTTProviderRevealedAndLinkAvailableAndDateNotKnown') && (
        <button
          className='addbtn-left btn btn-primary'
          type='button'
          onClick={() => addFields()}
        >
          Add
        </button>
      )}

      <OttPlatformPopUp
        pop={pop}
        setpop={setPop}
        options1={renderOttOptions}
        restrictpop={restrictpop}
      />
    </>
  )
}

export default Ottplatformlink
